import { render, staticRenderFns } from "./Set_department.vue?vue&type=template&id=75963f47"
import script from "./Set_department.vue?vue&type=script&lang=js"
export * from "./Set_department.vue?vue&type=script&lang=js"
import style0 from "./Set_department.vue?vue&type=style&index=0&id=75963f47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports